import { Divider, Input } from "@heroui/react";
import { Label } from "@radix-ui/react-label";
import type { UseFormReturn } from "react-hook-form";

type FormProps = Pick<UseFormReturn<any>, "watch" | "control">;
import { useTranslation } from "react-i18next";

import { CheckboxField, InputField } from "@/features/FormCard/Fields";
import { formatDate } from "@/features/FormCard/utils";

type Props = {
  id?: number;
  form: FormProps;
  table_name: string;
  showReadOnlyFields?: boolean;
  showBankConnectionField?: boolean;
};

export function PortfoliosTechnicalInfoSection({
  id,
  form,
  table_name,
  showReadOnlyFields = true,
  showBankConnectionField = true,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Divider />
      <Label>
        {t("sections.technical_info", {
          defaultValue: "Informations techniques",
        })}
      </Label>

      {showReadOnlyFields && id !== undefined && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            radius="full"
            variant="underlined"
            labelPlacement="outside"
            size="sm"
            type="text"
            label={t("technical_info.id", { defaultValue: "Id" })}
            value={id.toString()}
            readOnly
          />
          <Input
            radius="full"
            variant="underlined"
            labelPlacement="outside"
            size="sm"
            type="text"
            label={t("technical_info.created_at", { defaultValue: "Créé le" })}
            value={formatDate(form.watch("created_at"))}
            readOnly
          />
          <Input
            radius="full"
            variant="underlined"
            labelPlacement="outside"
            size="sm"
            type="text"
            label={t("technical_info.updated_at", {
              defaultValue: "Mis à jour le",
            })}
            value={formatDate(form.watch("updated_at"))}
            readOnly
          />
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
        <div className="flex flex-col gap-4">
          <InputField
            type="number"
            name="strategy_id"
            label={t(`${table_name}.columns.strategy_id`, {
              ns: "tables",
              defaultValue: "Id de la stratégie",
            })}
            control={form.control}
          />
          <InputField
            type="number"
            name="vehicle_index"
            allowDecimal={false}
            label={t(`${table_name}.columns.vehicle_index`, {
              ns: "tables",
              defaultValue: "Vehicle index (dv)",
            })}
            control={form.control}
          />
        </div>

        <div className="flex md:justify-end md:pr-2">
          <div className="flex flex-col gap-2 md:items-end">
            <CheckboxField
              name="has_pdf_bank_page"
              label={t("portfolios.pdf_account_page", {
                defaultValue: "Page du compte dans le rapport PDF",
              })}
              control={form.control}
            />
            <CheckboxField
              name="display_performance_report"
              label={t("portfolios.pdf_performance_page", {
                defaultValue: "Page de la performance dans le rapport PDF",
              })}
              control={form.control}
            />
            {showBankConnectionField && (
              <CheckboxField
                name="bank_connection"
                label={t("portfolios.bank_connection", {
                  defaultValue: "Connexion bancaire",
                })}
                control={form.control}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
